import { PendoMetaFields } from "globalConstants";
import { PendoDataType } from "types";

const {
	Id,
	Name,
	FirstName,
	LastName,
	AgentOffice,
	Email,
	MobilePhone,
	IsAgent,
	Role,
	Permissions,
	PartnerType,
	BusinessUnit,
	BusinessUnitHierarchy,
	Status,
	CreatedAt,
	StartDate,
	Package,
} = PendoMetaFields;

export const mapUserProfileToPendo = (data: {
	[key: string]: any;
}): PendoDataType =>
	({
		visitor: {
			[Id.name]: data?.[Id.beName],
			[FirstName.name]: data?.[FirstName.beName],
			[LastName.name]: data?.[LastName.beName],
			[AgentOffice.name]: data?.agent_office?.[Name.beName],
			[Email.name]: data?.[Email.beName],
			[MobilePhone.name]: data?.[MobilePhone.beName],
			[IsAgent.name]: data?.[IsAgent.beName],
			[Role.name]: data?.[Role.beName],
			[Permissions.name]: data?.[Permissions.beName],
			[PartnerType.name]: data?.[PartnerType.beName],
			[BusinessUnit.name]: data?.[BusinessUnit.beName],
			[BusinessUnitHierarchy.name]: data?.[BusinessUnitHierarchy.beName],
		},
		account: {
			[Id.name]: data?.agent_office?.[Id.beName],
			[Name.name]: data?.agent_office?.[Name.beName],
			[PartnerType.name]: data?.agent_office?.[PartnerType.beName],
			[Status.name]: data?.agent_office?.[Status.beName],
			[BusinessUnit.name]: data?.agent_office?.[BusinessUnit.beName],
			[BusinessUnitHierarchy.name]:
				data?.agent_office?.[BusinessUnitHierarchy.beName],
			[CreatedAt.name]: data?.agent_office?.[CreatedAt.beName],
			[StartDate.name]: data?.agent_office?.[StartDate.beName],
			[Package.name]: data?.agent_office?.[Package.beName],
		},
	} as PendoDataType);

export const mapUserProfileToPendoApi = (data: { [key: string]: any }) => ({
	visitor: {
		[Id.beName]: data?.[Id.beName],
		[FirstName.beName]: data?.[FirstName.beName],
		[LastName.beName]: data?.[LastName.beName],
		[AgentOffice.beName]: data?.agent_office?.[Name.beName],
		[Email.beName]: data?.[Email.beName],
		[MobilePhone.beName]: data?.[MobilePhone.beName],
		[IsAgent.beName]: data?.[IsAgent.beName],
		[Role.beName]: data?.[Role.beName],
		[Permissions.beName]: data?.[Permissions.beName],
		[PartnerType.beName]: data?.[PartnerType.beName],
		[BusinessUnit.beName]: data?.[BusinessUnit.beName],
		[BusinessUnitHierarchy.beName]: data?.[BusinessUnitHierarchy.beName],
	},
	account: {
		[Id.beName]: data?.agent_office?.[Id.beName],
		[Name.beName]: data?.agent_office?.[Name.beName],
		[PartnerType.beName]: data?.agent_office?.[PartnerType.beName],
		[Status.beName]: data?.agent_office?.[Status.beName],
		[BusinessUnit.beName]: data?.agent_office?.[BusinessUnit.beName],
		[BusinessUnitHierarchy.beName]:
			data?.agent_office?.[BusinessUnitHierarchy.beName],
		[CreatedAt.beName]: data?.agent_office?.[CreatedAt.beName],
		[StartDate.beName]: data?.agent_office?.[StartDate.beName],
		[Package.beName]: data?.agent_office?.[Package.beName],
	},
});
